(() => {
  if (window.canallaHomeBound) return;
  window.canallaHomeBound = true;
  // Decorative motion never gates content or purchasing.
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const mountStudio = () => {
    const visual = document.querySelector('.ch-hero__visual');
    if (!visual || visual.dataset.studioBound) return;
    visual.dataset.studioBound = 'true';
    let frame = 0;
    const reset = () => {
      cancelAnimationFrame(frame);
      visual.style.removeProperty('--ch-shift-x');
      visual.style.removeProperty('--ch-shift-y');
    };
    visual.addEventListener('pointermove', (event) => {
      if (motion.matches || !finePointer.matches) return;
      const rect = visual.getBoundingClientRect();
      const x = ((event.clientX - rect.left) / rect.width - .5) * 10;
      const y = ((event.clientY - rect.top) / rect.height - .5) * 6;
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        visual.style.setProperty('--ch-shift-x', x.toFixed(2) + 'px');
        visual.style.setProperty('--ch-shift-y', y.toFixed(2) + 'px');
      });
    });
    visual.addEventListener('pointerleave', reset);
    motion.addEventListener('change', reset);
  };
  mountStudio();
  document.addEventListener('shopify:section:load', mountStudio);
  document.addEventListener('click', (event) => {
    const action = event.target.closest('[data-home-action]');
    if (!action) return;
    document.dispatchEvent(new CustomEvent('canalla:home-action', {
      detail: {
        action: action.dataset.homeAction,
        productId: action.closest('[data-home-product]')?.dataset.homeProduct || null,
        destination: action.getAttribute('href') || null
      }
    }));
  });
})();
